import BlockContent from '@sanity/block-content-to-react';
import { Text } from 'components/ui/text';
import { rem } from 'polished';
import styled from 'styled-components';

export const StyledBlockContent = styled(BlockContent)`
  margin-top: ${rem(20)};
  color: ${({ theme }) => theme.components.text.text};
  line-height: 1.4;

  > * {
    margin: 0;
  }

  > * + * {
    margin-top: ${rem(20)};
  }

  p {
    line-height: inherit;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    + p,
    + ${Text} {
      margin-top: ${rem(10)};
    }
  }

  ul,
  ol {
    padding-left: ${rem(30)};

    * + * {
      margin-top: ${rem(10)};
    }
  }

  /* stylelint-disable -- Disabled so we can use specific order of properties
   Source: https://css-tricks.com/snippets/css/prevent-long-urls-from-breaking-out-of-container/
  */
  a {
    /* These are technically the same, but use both */
    overflow-wrap: break-word;
    word-wrap: break-word;

    -ms-word-break: break-all;
    /* This is the dangerous one in WebKit, as it breaks things wherever */
    word-break: break-all;
    /* Instead use this non-standard one: */
    word-break: break-word;

    /* Adds a hyphen where the word breaks, if supported (No Blink) */
    -ms-hyphens: auto;
    -moz-hyphens: auto;
    -webkit-hyphens: auto;
    hyphens: auto;
  }
  /* stylelint-enable */
`;
